import { useTheme } from '@mui/material';

/** Backdrop
 *  A custom backdrop element to darken the backgroun elements when making custom modals
 */
const Backdrop = (props) => {
  const { type = 'light', open, handleClose } = props;
  const theme = useTheme();
  return (
    <div
      onClick={handleClose}
      aria-hidden={open}
      style={{
        opacity: open ? '100%' : '0%',
        backgroundColor: open && type === 'light' ? 'rgba(0, 0, 0, 0.15)' : 'rgba(0, 0, 0, 0.5)',
        pointerEvents: open ? 'auto' : 'none',
        width: '100vw',
        height: '100vh',
        position: 'fixed',
        left: '0',
        right: '0',
        zIndex: 1201,
        transition: 'opacity .25s ease-in-out, background-color .25s ease-in-out',
        cursor: 'pointer',
        willChange: 'opacity',
        overflow: 'hidden',
      }}
    />
  );
};

export default Backdrop;
